<template>
  <el-select :value="value" @input="$emit('input', $event)" @change="$emit('change', $event)">
    <el-option v-for="item in options" :key="item.value" :value="item.type" :label="item.name"/>
  </el-select>
</template>

<script>
import { fetchByKey } from '@/api/system/config'
let _vue = null
const DATA_ROUTER_MAP = {
  BIG_SCREEN: 'bigScreenTypes',
  MOBILE_MANAGE: 'mobileManageTypes',
  MANAGE: 'manageTypes'
}
export default {
  props: {
    value: {},
    scope: {},
    docType: {},
    template: {}
  },
  name: 'BookTextTypeSelect',
  data () {
    return {
      // 说明书数据
      introduceData: [],
      // 招标书模版数据
      zbsTemplateData: [],
      // 招标书模块数据
      zbsModulesData: [],
      // 管理系统模版
      manageTypes: {
        // 说明书
        zbs: {
          template: [],
          module: []
        },
        // 系统说明书
        sysInt: {
          template: []
        }
      },
      // 移动端管理系统模版
      mobileManageTypes: {
        // 说明书
        zbs: {
          template: [],
          module: []
        },
        // 系统说明书
        sysInt: {
          template: []
        }
      },
      // 大屏系统模版
      bigScreenTypes: {
        // 说明书
        zbs: {
          template: [],
          module: []
        },
        // 系统说明书
        sysInt: {
          template: []
        }
      }
    }
  },
  computed: {
    currentTemplate () {
      return _vue[DATA_ROUTER_MAP[this.template]]
    },
    options () {
      // 招标书
      if (_vue.docType === 'ZBS') {
        if (_vue.scope === 'TEMPLATE' && _vue.currentTemplate.zbs.template.length > 0) {
          return _vue.currentTemplate.zbs.template
        }
        if (_vue.scope === 'MODULE' && _vue.currentTemplate.zbs.module.length > 0) {
          return _vue.currentTemplate.zbs.module
        }
        return []
      }
      // 系统说明书
      else if (_vue.docType === 'SYS_INT' && _vue.currentTemplate.sysInt.template.length > 0) {
        return _vue.currentTemplate.sysInt.template
      }
      return []
    }
  },
  watch: {
    currentTemplate () {
      this.fetchOptions()
    }
  },
  methods: {
    // 配置接口说明书数据
    fetchByKeyIntroduce () {
      if (this.currentTemplate.sysInt.template.length > 0) {
        return
      }
      fetchByKey('book:system:introduce:config')
        .then(data => {
          this.currentTemplate.sysInt.template = JSON.parse(data.value).scopes[0].textTypes
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 配置接口招标书数据
    fetchByKeyZbs (systemConfigKey) {
      if (this.currentTemplate.zbs.template.length > 0) {
        return
      }
      fetchByKey(systemConfigKey)
        .then(data => {
          this.currentTemplate.zbs.template = JSON.parse(data.value).scopes[0].textTypes
          this.currentTemplate.zbs.module = JSON.parse(data.value).scopes[1].textTypes
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 初始化
    fetchOptions () {
      this.fetchByKeyIntroduce()
      // 大屏系统
      if (this.template === 'BIG_SCREEN') {
        this.fetchByKeyZbs('bigscreen:book:zbs:config')
        return
      }
      // 移动端管理系统
      if (this.template === 'MOBILE_MANAGE') {
        this.fetchByKeyZbs('mobile:manage:book:zbs:config')
        return
      }
      // 管理系统
      if (this.template === 'MANAGE') {
        this.fetchByKeyZbs('book:zbs:config')
      }
    }
  },
  beforeCreate () {
    _vue = this
  },
  created () {
    this.fetchOptions()
  }
}
</script>
